import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { NgModule } from '@angular/core';
import { SharedLibsModule } from './shared-libs.module';
import { SharedCommonModule } from './shared-common.module';
import { LoadingComponent } from './components/loading/loading.component';
import { RequiredIfDirective } from './directives/required-if.directive';
import { EmailValidatorDirective } from './directives/email-validator.directive';
import { FooterComponent } from './components/internal/internal-footer/footer.component';
import { ExternalFooterComponent } from './components/external/external-footer/footer.component';
import { DialogsConfirmComponent } from './components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { DialogsAlertComponent } from './components/dialogs/dialogs-alert/dialogs-alert.component';
import { DialogsPermissionsComponent } from './components/dialogs/dialogs-permissions/dialogs-permissions.component';
import { DialogsPermissionsService } from './components/dialogs/dialogs-permissions/dialogs-permissions.service';
import { DialogsBuscadorComponent } from './components/dialogs/dialogs-buscador/dialogs-buscador.component';
import { DialogsDatoswsComponent } from './components/dialogs/dialogs-datosws/dialogs-datosws.component';
import { DialogsBuscadorService } from './components/dialogs/dialogs-buscador/dialogs-buscador.service';
import { DialogsAvisosComponent } from './components/dialogs/dialogs-avisos/dialogs-avisos.component';
import { DialogsAvisosService } from './components/dialogs/dialogs-avisos/dialogs-avisos.service';
import { DialogsPerfilComponent } from './components/dialogs/dialogs-perfil/dialogs-perfil.component';
import { DialogsPerfilService } from './components/dialogs/dialogs-perfil/dialogs-perfil.service';
import { DialogsTercerComponent } from './components/dialogs/dialogs-tercer/dialogs-tercer.component';
import { DialogsTercerService } from './components/dialogs/dialogs-tercer/dialogs-tercer.service';
import { DialogsRepresentantComponent } from './components/dialogs/dialogs-representant/dialogs-representant.component';
import { DialogsRepresentantService } from './components/dialogs/dialogs-representant/dialogs-representant.service';
import { DialogsRepresentantAocComponent } from './components/dialogs/dialogs-representant-aoc/dialogs-representant-aoc.component';
import { DialogsRepresentantAOCService } from './components/dialogs/dialogs-representant-aoc/dialogs-representant-aoc.service';
import { DialogsSendMailsComponent } from './components/dialogs/dialogs-send-mails/dialogs-send-mails.component';
import { DialogsSendMailsService } from './components/dialogs/dialogs-send-mails/dialogs-send-mails.service';
import { DialogsBuscadorExternaComponent } from './components/dialogs/dialogs-buscador-externa/dialogs-buscador-externa.component';
import { PreheaderComponent } from './components/external/preheader/preheader.component';
import { DonasComponent } from './components/graficos/donas/donas.component';
import { Donas2Component } from './components/graficos/donas/donas2.component';
import { Donas3Component } from './components/graficos/donas/donas3.component';
import { Donas4Component } from './components/graficos/donas/donas4.component';
import { Donas5Component } from './components/graficos/donas/donas5.component';

@NgModule({
    imports: [
        SharedCommonModule,
        SharedLibsModule
    ],
    declarations: [
        LoadingComponent,
        FooterComponent,
        SafeHtmlPipe,
        TruncatePipe,
        RequiredIfDirective,
        EmailValidatorDirective,
        ExternalFooterComponent,
        DialogsConfirmComponent,
        DialogsAlertComponent,
        DialogsPermissionsComponent,
        DialogsBuscadorComponent,
        DialogsAvisosComponent,
        DialogsPerfilComponent,
        DialogsDatoswsComponent,
        DialogsTercerComponent,
        DialogsRepresentantComponent,
        DialogsRepresentantAocComponent,
        DialogsSendMailsComponent,
        DialogsBuscadorExternaComponent,
        PreheaderComponent,
        DonasComponent,
        Donas2Component,
        Donas3Component,
        Donas4Component,
        Donas5Component
    ],
    exports: [
        SharedCommonModule,
        SharedLibsModule,
        PreheaderComponent,
        FooterComponent,
        ExternalFooterComponent,
        LoadingComponent,
        SafeHtmlPipe,
        TruncatePipe,
        RequiredIfDirective,
        EmailValidatorDirective,
        DialogsConfirmComponent,
        DialogsAlertComponent,
        DialogsPermissionsComponent,
        DialogsBuscadorComponent,
        DialogsAvisosComponent,
        DialogsPerfilComponent,
        DialogsDatoswsComponent,
        DialogsTercerComponent,
        DialogsRepresentantComponent,
        DialogsRepresentantAocComponent,
        DialogsSendMailsComponent,
        DialogsBuscadorExternaComponent,
        DonasComponent,
        Donas2Component,
        Donas3Component,
        Donas4Component,
        Donas5Component
    ],
    providers: [
        DialogsPermissionsService,
        DialogsBuscadorService,
        DialogsAvisosService,
        DialogsPerfilService,
        DialogsTercerService,
        DialogsRepresentantService,
        DialogsRepresentantAOCService,
        DialogsSendMailsService
    ]
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      providers: [
        DialogsPermissionsService, 
        DialogsBuscadorService, 
        DialogsAvisosService,
        DialogsPerfilService,
        DialogsTercerService,
        DialogsRepresentantService,
        DialogsRepresentantAOCService,
        DialogsSendMailsService
      ]
    }
  }
 }
